import React from 'react'
import styled from 'styled-components'
import { useSelector } from 'react-redux'
import Spinner from 'react-bootstrap/Spinner'
import ProgressBar from 'react-bootstrap/ProgressBar'
import Row from 'react-bootstrap/Row'
import Col from 'react-bootstrap/Col'
import Container from 'react-bootstrap/Container'
import { RootState } from 'app/state/types'

const Overlay = styled.div`
    z-index: 9400;
    position: absolute;
    display: flex;
    justify-content: center;
    align-items: center;
    height: 100%;
    width: 100%;
    background-color: rgba(0, 0, 0, 0.5);
    backdrop-filter: blur(6px);
    top: 0;
    left: 0;
    flex-direction: column;
    text-align: center;
    color: whitesmoke;
`

const ProgressRow = styled(Row)`
    align-items: center;
    justify-content: center;
    align-content: center;
    align-self: center;
`

const StyledProgress = styled(ProgressBar)`
    color: white;
    align-items: center;
    justify-content: center;
    align-content: center;
    align-self: center;
    padding: 0;
    margin: 0;
`

const Loader = () => {
    const { isLoading, loadingProgress } = useSelector(
        (state: RootState) => state.appSlice,
    )

    if (!isLoading) return null

    return (
        <Overlay>
            {loadingProgress === -1 && <Spinner animation="border" />}
            <h2>{'Loading...'}</h2>
            {loadingProgress !== -1 && (
                <Container>
                    <Col xs="auto">
                        <ProgressRow>
                            <StyledProgress
                                animated
                                now={loadingProgress}
                                label={`${loadingProgress}%`}
                            />
                        </ProgressRow>
                    </Col>
                </Container>
            )}
        </Overlay>
    )
}

export default Loader
